import {
  LayoutDashboard,
  Users,
  Wallet,
  CreditCard,
  CheckSquare,
  BarChart3,
  IdCard,
  Settings,
  Handshake,
  UserCircle,
  ArrowDownCircle,
  ArrowUpCircle,
  ScrollText,
  Landmark,
  PieChart,
  Lock,
  Activity,
  History,
  Network,
  Plug,
  Bot,
  Megaphone,
} from 'lucide-react';

// Fonte única da navegação. `minLevel` aplica RBAC (ver lib/rbac.js).
// Itens são agrupados por seção; cada seção pode colapsar no Sidebar.
// Financeiro dividido em Tesouraria (caixa/dia a dia) e Controladoria
// (competência/resultados) — ver docs/PLANO_REESTRUTURACAO_FINANCEIRO.md.
export const NAV_GROUPS = [
  {
    label: null, // grupo principal sem cabeçalho
    items: [{ to: '/', label: 'Dashboard', icon: LayoutDashboard }],
  },
  {
    label: 'Relacionamento',
    items: [
      { to: '/cadastro', label: 'Cadastro', icon: Users },
    ],
  },
  {
    label: 'Tesouraria',
    minLevel: 'financeiro', // bloqueado para gestor/operacional
    items: [
      { to: '/contas-receber', label: 'Contas a Receber', icon: ArrowDownCircle },
      { to: '/contas-pagar', label: 'Contas a Pagar', icon: ArrowUpCircle },
      { to: '/extrato', label: 'Extrato & Movimentações', icon: ScrollText },
      { to: '/fluxo-caixa', label: 'Fluxo de Caixa', icon: Activity },
      { to: '/aprovacoes', label: 'Aprovações', icon: CheckSquare },
      { to: '/contas', label: 'Contas Bancárias', icon: Landmark },
      { to: '/cartoes', label: 'Cartões de Crédito', icon: CreditCard },
    ],
  },
  {
    label: 'Controladoria',
    minLevel: 'financeiro',
    items: [
      { to: '/dre', label: 'DRE Gerencial', icon: PieChart },
      { to: '/fechamentos', label: 'Fechamentos & Exercícios', icon: Lock },
      { to: '/relatorios', label: 'Relatórios', icon: BarChart3 },
      { to: '/retroativos', label: 'Lançamentos Retroativos', icon: History },
    ],
  },
  {
    // Decisão V2-F07: Sócios sai do Financeiro e mora aqui, junto da equipe.
    label: 'Pessoas & Resultados',
    minLevel: 'gestor',
    items: [
      { to: '/funcionarios', label: 'Colaboradores', icon: IdCard },
      { to: '/rh-pdi', label: 'PDI & Carreira', icon: CheckSquare, badge: 'Em breve' },
      { to: '/socios', label: 'Sócios & Resultado', icon: Handshake, minLevel: 'financeiro' },
    ],
  },
  {
    label: 'Sistemas',
    minLevel: 'financeiro',
    items: [
      { to: '/ia-chatbot', label: 'IA & Chatbot', icon: Bot, minLevel: 'admin', badge: 'Em breve' },
      { to: '/asaas-massa', label: 'Cobranças em Massa', icon: Megaphone, minLevel: 'financeiro', badge: 'Em breve' },
      { to: '/sistemas/monitoramento', label: 'Monitoramento', icon: Network, minLevel: 'admin' },
      { to: '/sistemas/integracoes', label: 'Integrações', icon: Plug, minLevel: 'admin' },
      { to: '/configuracoes', label: 'Configurações', icon: Settings, minLevel: 'admin' },
    ],
  },
  // Rotas sem entrada no sidebar (usadas somente pelo topbar para título)
  {
    label: null,
    hidden: true,
    items: [
      { to: '/meu-perfil', label: 'Meu Perfil', icon: UserCircle },
      { to: '/lancamentos', label: 'Lançamentos', icon: Wallet },
    ],
  },
];
